import { api } from "@/api";

/** Télécharge un fichier protégé par JWT (blob) et déclenche l'enregistrement ou l'ouverture. */
export async function downloadAuth(url, filename, { open = false, params } = {}) {
  const r = await api.get(url, { responseType: "blob", params });
  const blobUrl = URL.createObjectURL(r.data);
  if (open) {
    window.open(blobUrl, "_blank", "noopener");
  } else {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename || (r.headers["content-disposition"] || "").split("filename=")[1]?.replace(/"/g, "") || "export";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return r;
}
